export { BaseForm } from './Base';
export { Select } from './Select';
export { NumberField } from './Number';
export { Text } from './Text';
export { TextArea } from './TextArea';
export { ColorField } from './Color';
export { CheckboxField as Checkbox } from './Checkbox';
export { default as CompanySelect } from './CompanySelect';
export { CountrySelect } from './CountrySelect';
export { default as TerritorySelect } from './TerritorySelect';
export { MultiSelect } from './MultiSelect';
export { DateTime } from './DateTime';
export { default as Image } from './Image';

export interface FormState {
  loading: boolean;
  error?: Error;
  saved: boolean;
}

export const resetFormState = (state: any): any => {
  return {
    error: null,
    loading: false,
    saved: false,
    ...state,
  };
};
